import { Overtime } from "@farmact/model/src/model/Overtime";
import { faBusinessTime, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { ComponentPropsWithoutRef, useState } from "react";
import { timeFormatter } from "../../../../../../../util/pdf/timeFormatter";
import "./tableGroupOvertime.scss";
import "../tableGroupTopLevel.scss";
import { IonButton } from "@ionic/react";
import { IconWithTooltip } from "../../../../../../IconWithTooltip";
import { EditOvertimeModal } from "./EditOvertimeModal/EditOvertimeModal";

interface ITableGroupOvertimeProps extends ComponentPropsWithoutRef<"div"> {
    overtime: Overtime;
    canEdit: boolean;
}

export const TableGroupOvertime = (props: ITableGroupOvertimeProps) => {
    const [editOverTimeModalIsOpen, setEditOvertimeModalIsOpen] = useState(false);

    return (
        <div {...props} className={"table-group-top-level table-group-overtime"}>
            <div className="table-group-top-level__cell table-group-top-level__date">
                <IconWithTooltip icon={faBusinessTime} iconClassName="group-icon" color="primary">
                    {props.overtime.note || "Manuell eingepflegte Überstunden"}
                </IconWithTooltip>

                <span className="group-date__day">{formatDay(props.overtime.date)}</span>
                <span className="group-date__date">{formatDate(props.overtime.date)}</span>
            </div>
            <div className="table-group-top-level__cell table-group-top-level__work-time"></div>
            <div className="table-group-top-level__cell table-group-top-level__time">
                {timeFormatter.formatFromHours(props.overtime.amount)}
            </div>
            <div className="table-group-top-level__cell table-group-top-level__break"></div>
            <div className="table-group-top-level__cell table-group-top-level__total">
                {timeFormatter.formatFromHours(props.overtime.amount)}
            </div>
            <div className="table-group-top-level__cell table-group-top-level__activities"></div>
            <div className="table-group-top-level__cell table-group-top-level__notes">{props.overtime.note}</div>
            <div className="table-group-top-level__cell">
                {props.canEdit && (
                    <IonButton
                        size="small"
                        fill="clear"
                        color="primary"
                        onClick={() => setEditOvertimeModalIsOpen(true)}>
                        <FontAwesomeIcon icon={faPencil} />
                    </IonButton>
                )}
            </div>
            <EditOvertimeModal
                isOpen={editOverTimeModalIsOpen}
                onDismiss={() => setEditOvertimeModalIsOpen(false)}
                overtime={props.overtime}
            />
        </div>
    );
};

function formatDay(day: string): string {
    return dayjs(day).locale("de").format("dd.");
}

function formatDate(day: string): string {
    return dayjs(day).locale("de").format("DD.MM");
}
